// document.addEventListener('DOMContentLoaded', () => {
//     async function shopify_api(e){return"/products/find-your-mobile-device-here"==window.location.pathname&&(e="find-your-mobile-device-here"),(await fetch(e)).json()}async function variant_get(e,t){const{product:i}=await shopify_api(`/products/${e}.json`);document.querySelector('.product-variant-id[name="id"]').value="";let r="";t&&i.variants.forEach(((e,t)=>{const o=i.images.filter((t=>t.id==e.image_id)),s=o[0]?.alt,n=e.id,a=e.title;void 0!==o[0]?.src?r+=`<div class="parent-skin-variant">\n                    <div class="skin-variant-image"> \n                        <svg id="zoom-icon-cst-skin" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"> \n                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16407 6.57748C1.16709 3.99351 2.99488 1.77145 5.52975 1.2701C8.06463 0.768736 10.6007 2.12769 11.5871 4.51596C12.5736 6.90423 11.7358 9.65675 9.58595 11.0904C7.43614 12.524 4.57304 12.2395 2.7474 10.4108C1.73196 9.3937 1.16238 8.01472 1.16407 6.57748Z" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"/> \n                            <path d="M9.96875 10.8066L12.8338 13.6608" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7.07812 4.22046C7.07812 3.94432 6.85427 3.72046 6.57813 3.72046C6.30198 3.72046 6.07813 3.94432 6.07813 4.22046H7.07812ZM6.07813 6.57748C6.07813 6.85362 6.30198 7.07748 6.57813 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748H6.07813ZM7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748H7.07812ZM6.07812 8.9345C6.07812 9.21065 6.30198 9.4345 6.57812 9.4345C6.85427 9.4345 7.07812 9.21065 7.07812 8.9345H6.07812ZM6.57812 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748V7.07748ZM4.2211 6.07748C3.94496 6.07748 3.7211 6.30134 3.7211 6.57748C3.7211 6.85362 3.94496 7.07748 4.2211 7.07748L4.2211 6.07748ZM6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748C6.07812 6.85362 6.30198 7.07748 6.57812 7.07748V6.07748ZM8.93515 7.07748C9.21129 7.07748 9.43515 6.85362 9.43515 6.57748C9.43515 6.30134 9.21129 6.07748 8.93515 6.07748V7.07748ZM6.07813 4.22046V6.57748H7.07812V4.22046H6.07813ZM6.07812 6.57748V8.9345H7.07812V6.57748H6.07812ZM6.57812 6.07748L4.2211 6.07748L4.2211 7.07748H6.57812V6.07748ZM6.57812 7.07748H8.93515V6.07748L6.57812 6.07748V7.07748Z" fill="#726F6F"/> \n                        </svg> \n                        <img class="product_variant_image img_btn ${0==t&&"selected"}" variant-id="${n}" src="${o[0]?.src}&width=800" alt=${s} price="${parseInt(e.price)}" price="${parseInt(e.price)}" compare_at_price="${e.compare_at_price}" title="${a}" /> \n                        <h4 class="product_variant_title">${a}</h4> \n                    </div> \n                    <div style="display:none;" class="skin-image-preview-popup"> \n                        <div class="close-button-skin-image-preview">\n                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">\n                                <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#0C1C33"/>\n                            </svg> \n                        </div> \n                        <div class="selected-skin-image-preview">\n                            <img class="product_variant_image"  src="${o[0]?.src}&width=800" alt=${s} loading="lazy" >\n                        </div> \n                    </div> \n                </div> `:r+='<div class="visually-hidden"> </div>',0==t&&(document.querySelector('.product-variant-id[name="id"]').value=n)})),!t&&i.images.forEach(((e,t)=>{const i=e.src,o=e?.alt||"Skin";r+=`<div class="parent-skin-variant"><div class="skin-variant-image"> <svg id="zoom-icon-cst-skin" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16407 6.57748C1.16709 3.99351 2.99488 1.77145 5.52975 1.2701C8.06463 0.768736 10.6007 2.12769 11.5871 4.51596C12.5736 6.90423 11.7358 9.65675 9.58595 11.0904C7.43614 12.524 4.57304 12.2395 2.7474 10.4108C1.73196 9.3937 1.16238 8.01472 1.16407 6.57748Z" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"/> <path d="M9.96875 10.8066L12.8338 13.6608" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7.07812 4.22046C7.07812 3.94432 6.85427 3.72046 6.57813 3.72046C6.30198 3.72046 6.07813 3.94432 6.07813 4.22046H7.07812ZM6.07813 6.57748C6.07813 6.85362 6.30198 7.07748 6.57813 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748H6.07813ZM7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748H7.07812ZM6.07812 8.9345C6.07812 9.21065 6.30198 9.4345 6.57812 9.4345C6.85427 9.4345 7.07812 9.21065 7.07812 8.9345H6.07812ZM6.57812 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748V7.07748ZM4.2211 6.07748C3.94496 6.07748 3.7211 6.30134 3.7211 6.57748C3.7211 6.85362 3.94496 7.07748 4.2211 7.07748L4.2211 6.07748ZM6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748C6.07812 6.85362 6.30198 7.07748 6.57812 7.07748V6.07748ZM8.93515 7.07748C9.21129 7.07748 9.43515 6.85362 9.43515 6.57748C9.43515 6.30134 9.21129 6.07748 8.93515 6.07748V7.07748ZM6.07813 4.22046V6.57748H7.07812V4.22046H6.07813ZM6.07812 6.57748V8.9345H7.07812V6.57748H6.07812ZM6.57812 6.07748L4.2211 6.07748L4.2211 7.07748H6.57812V6.07748ZM6.57812 7.07748H8.93515V6.07748L6.57812 6.07748V7.07748Z" fill="#726F6F"/> </svg> <img class="product_variant_image" src="${i}&width=800" alt="${o}"/> <h4 class="product_variant_title">${o}</h4></div> <div style="display:none;" class="skin-image-preview-popup"> <div class="close-button-skin-image-preview"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#0C1C33"/></svg> </div> <div class="selected-skin-image-preview"><img class="product_variant_image" loading="lazy" src="${i}&width=800" alt="${o}"></div> </div> </div> `})),document.querySelector(".variant-images-to-show").innerHTML=r,document.querySelector(".variant-images-to-show").innerHTML=r,document.querySelector(".product_variant_image.img_btn.selected")?.click(),attachEventListeners()}const select_custom_brand=document.querySelector(".select_custom_brand"),select_custom_model=document.querySelector("#select_custom_model"),select_skin_type=document.querySelector("#skin-type"),product_variant_image=document.querySelector(".custom-variant-option .variant-images-to-show");async function handleBrandChange(e){const t=document.querySelector(".special_note");t&&(t.style.display="motorola"===e?"block":"none");const i=select_custom_brand.querySelector(`option[value=${e}]`),r=i.getAttribute("handle");let o=i.getAttribute("data-models");"/products/find-your-mobile-device-here"!=window.location.pathname&&(o=o.split("&&"));let s="";"/products/find-your-mobile-device-here"!=window.location.pathname&&o.forEach(((e,t)=>{const i=e.split(",");0===t&&(s+='<option value="-1" disabled selected>Select Model</option>'),s+=`<option value="${i[1].trim()}" handle="${i[1].trim()}">${i[0].trim()}</option>`})),"/products/find-your-mobile-device-here"==window.location.pathname&&(o=o.split(","),o.forEach(((t,i)=>{const r=t.trim();0===i&&(s+='<option value="-1" disabled selected>Select Model</option>'),""!==r&&(s+=`<option value="${e}" handle="${r}">${r}</option>`)})),document.querySelector('[name="properties[Brand]"]').value=e),select_custom_model.innerHTML=s,section_id=document.querySelector(".product.product--left").closest(".section").getAttribute("id").replace("shopify-section-","");const n=(await shopify_api(`/products/${r}?view=build-skin&sections=${section_id}`))[section_id],a=(new DOMParser).parseFromString(n,"text/html").querySelector("media-gallery").innerHTML;document.querySelector("media-gallery").innerHTML=a,variant_get(r,!1)}if(select_custom_brand.addEventListener("change",(function(){handleBrandChange(this.value)})),"/products/find-your-mobile-device-here"!=window.location.pathname){var SkinBrand=new URLSearchParams(window.location.search).get("skin-brand");null!=SkinBrand&&(select_custom_brand.value=SkinBrand,handleBrandChange(`${SkinBrand}`))}select_custom_model.addEventListener("change",(async function(){const e=this.value,t=this.querySelector(`option[value=${e}]`).getAttribute("handle"),i=document.querySelector(".product.product--left").closest(".section").getAttribute("id").replace("shopify-section-","");"/products/find-your-mobile-device-here"==window.location.pathname&&(document.querySelector('[name="properties[Model]"]').value=select_custom_model.selectedOptions[0].textContent);const r=(await shopify_api(`/products/${t}?view=build-skin&sections=${i}`))[i],o=(new DOMParser).parseFromString(r,"text/html"),s=o.querySelector("media-gallery").innerHTML;o.querySelector("product-form");document.querySelector("media-gallery").innerHTML=s;const n=o.querySelector("product-info .product__title h1").innerHTML;document.querySelectorAll(".product__title");document.querySelector(".sticky-buy-buttons .product__title h3").innerHTML=n;const a=document?.querySelector(".d-none-price");a&&(a.style.display="block"),document.querySelector(".sticky-buy-buttons .product__title h3").style.color="#7b7b7b",document.querySelector(".sticky-buy-buttons .product__title h3").style.fontSize="12px",document.querySelector(".sticky-buy-buttons .product__title h3").style.lineHeight="12px",document.querySelector(".sticky-buy-buttons .d-none-mrp").style.display="block",variant_get(t,!0)})),select_skin_type.addEventListener("change",(async function(){document.querySelector('[name="properties[Wrapping]"]').value=select_skin_type.value}));const sticky_buy_buttons=document.querySelector(".sticky-buy-buttons"),variant__title_buy=document.querySelector(".product-details .variant__title_buy");function attachEventListeners(){document.body.addEventListener("click",(function(e){if(e.target.matches("#zoom-icon-cst-skin")){const t=e.target.closest(".parent-skin-variant"),i=t?t.querySelector(".skin-image-preview-popup"):null;i&&(i.style.display="block")}if(e.target.matches(".close-button-skin-image-preview")){const t=e.target.closest(".skin-image-preview-popup");t&&(t.style.display="none")}if(e.target.closest(".skin-image-preview-popup")){const t=e.target.closest(".skin-image-preview-popup");t.querySelector(".selected-skin-image-preview").contains(e.target)||(t.style.display="none")}}))}if(variant__title_buy&&""===variant__title_buy.innerText&&(sticky_buy_buttons.style.display="none"),product_variant_image?.addEventListener("click",(function(e){const t=e.target,i=t.closest(".product_variant_image.img_btn");if(t.closest(".product_variant_image")){const e=t.closest(".product_variant_image"),i=t.closest(".product_variant_image").getAttribute("src").split("?")[0];document.querySelector("modal-opener .product__media img").setAttribute("srcset",i),document.querySelector("modal-opener .product__media img").setAttribute("src",i),document.querySelector("product-modal .product-media-modal__content img").setAttribute("srcset",i),document.querySelectorAll(".product_variant_image").forEach((e=>e.classList.remove("selected"))),document.querySelectorAll(".skin-variant-image").forEach((e=>e.classList.remove("selected"))),e.classList.add("selected");const r=e.closest(".skin-variant-image");r?.classList.add("selected");const sectionElement = document.querySelector('.product--thumbnail_slider');if (sectionElement) {sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });}const o=r?.querySelector(".product_variant_title")?.innerText||"";document.querySelector(".variant__title_buy")&&(document.querySelector(".variant__title_buy").innerText=o),sticky_buy_buttons.style.display="flex","/products/find-your-mobile-device-here"==window.location.pathname&&(document.querySelector('[name="properties[Find My Device]"]').value=o),document.querySelector(".product__info-wrapper").classList.add("visible-btn")}if(t.closest(".product_variant_image.img_btn")){const e=t.getAttribute("variant-id");document.querySelector('.product-variant-id[name="id"]').value=e,document.querySelectorAll(".product_variant_image").forEach((function(e){e.classList.remove("selected")})),t.classList.add("selected");const r=i.getAttribute("price");console.log(t,t.closest(".product__column-sticky"),r,"proce");const o=(t.closest(".product__column-sticky").querySelector("product-info span.price-item.price-item--sale").innerText.match(/[^0-9.,]+/)?.[0]||"")+Math.floor(parseFloat(r));document.querySelector("product-info span.price-item.price-item--sale").innerHTML=o,console.log(o,"gp");let s=i.getAttribute("compare_at_price");t.closest(".product__column-sticky").querySelector(".sticky-buy-buttons .price--on-sale .price-item--regular span.money").innerText;null!=s&&""!=s&&(s="₹ "+s),document.querySelector(".sticky-buy-buttons .price--on-sale .price-item--regular span.money").innerHTML=s}})),attachEventListeners(),document.querySelector(".built-default-title")){document.body.classList.add("overlay--loading");var select=document.querySelector(".select_custom_brand"),pocoOption=Array.from(select.options).find((function(e){return e.text.toLowerCase().includes(document.querySelector(".built-default-title").innerText.toLowerCase())}));if(pocoOption){select.value=pocoOption.value;var event=new Event("change",{bubbles:!0});select.dispatchEvent(event),setTimeout((function(){document.body.classList.remove("overlay--loading")}),1e3)}else document.body.classList.remove("overlay--loading")}customElements.get("product-form")||customElements.define("product-form",class extends HTMLElement{constructor(){super(),this.form=this.querySelector("form"),this.variantIdInput.disabled=!1,this.form.addEventListener("submit",this.onSubmitHandler.bind(this)),this.cart=document.querySelector("cart-notification")||document.querySelector("cart-drawer"),this.submitButton=this.querySelector('[type="submit"]'),this.submitButtonText=this.submitButton.querySelector("span"),document.querySelector("cart-drawer")&&this.submitButton.setAttribute("aria-haspopup","dialog"),this.hideErrors="true"===this.dataset.hideErrors}onSubmitHandler(e){if(e.preventDefault(),"true"===this.submitButton.getAttribute("aria-disabled"))return;this.handleErrorMessage(),this.submitButton.setAttribute("aria-disabled",!0),this.submitButton.classList.add("loading"),this.querySelector(".loading__spinner").classList.remove("hidden");var t="";const i=new FormData(this.form);this.cart&&(i.append("sections",this.cart.getSectionsToRender().map((e=>e.id))),i.append("sections_url",window.location.pathname),this.cart.setActiveElement(document.activeElement)),(t=fetchConfig("javascript")).headers["X-Requested-With"]="XMLHttpRequest",delete t.headers["Content-Type"],t.body=i,document.body.id;{const e=document.querySelector("#select_custom_model"),t=document.querySelector("#skin-type");if(e&&"-1"==e.value){const t=this;return setTimeout((function(){t.submitButton.classList.remove("loading"),t.cart&&t.cart.classList.contains("is-empty")&&t.cart.classList.remove("is-empty"),t.error||t.submitButton.removeAttribute("aria-disabled"),t.querySelector(".loading__spinner").classList.add("hidden")}),1e3),e.scrollIntoView({behavior:"smooth",block:"center"}),void this.handleErrorMessage("Please select model name")}if(t&&"-1"==t.value){const e=this;return setTimeout((function(){e.submitButton.classList.remove("loading"),e.cart&&e.cart.classList.contains("is-empty")&&e.cart.classList.remove("is-empty"),e.error||e.submitButton.removeAttribute("aria-disabled"),e.querySelector(".loading__spinner").classList.add("hidden")}),1e3),t.scrollIntoView({behavior:"smooth",block:"center"}),void this.handleErrorMessage("Please select Wrapping")}}fetch(`${routes.cart_add_url}${46994527486189!=i.get("id")&&46994499436781!=i.get("id")&&46994527518957!=i.get("id")?"":".js"}`,t).then((e=>e.json())).then((e=>{if(e.status){publish(PUB_SUB_EVENTS.cartError,{source:"product-form",productVariantId:i.get("id"),errors:e.errors||e.description,message:e.message}),this.handleErrorMessage(e.description);const t=this.submitButton.querySelector(".sold-out-message");if(!t)return;return this.submitButton.setAttribute("aria-disabled",!0),this.submitButtonText.classList.add("hidden"),t.classList.remove("hidden"),void(this.error=!0)}if(!this.cart)return void(window.location=window.routes.cart_url);this.error||publish(PUB_SUB_EVENTS.cartUpdate,{source:"product-form",productVariantId:i.get("id"),cartData:e}),this.error=!1;const t=this.closest("quick-add-modal");t?(document.body.addEventListener("modalClosed",(()=>{setTimeout((()=>{this.cart.renderContents(e)}))}),{once:!0}),t.hide(!0)):this.cart.renderContents(e)})).catch((e=>{console.error(e)})).finally((()=>{this.submitButton.classList.remove("loading"),this.cart&&this.cart.classList.contains("is-empty")&&this.cart.classList.remove("is-empty"),this.error||this.submitButton.removeAttribute("aria-disabled"),this.querySelector(".loading__spinner").classList.add("hidden")}))}handleErrorMessage(e=!1){this.hideErrors||(this.errorMessageWrapper=this.errorMessageWrapper||this.querySelector(".product-form__error-message-wrapper"),this.errorMessageWrapper&&(this.errorMessage=this.errorMessage||this.errorMessageWrapper.querySelector(".product-form__error-message"),this.errorMessageWrapper.toggleAttribute("hidden",!e),e&&(this.errorMessage.textContent=e)))}toggleSubmitButton(e=!0,t,i=0){e?(this.submitButton.setAttribute("disabled","disabled"),t&&(this.submitButtonText.textContent=t)):(this.submitButton.removeAttribute("disabled"),this.submitButtonText.textContent=window.variantStrings.addToCart)}get variantIdInput(){return this.form.querySelector("[name=id]")}});
// });


const DEFAULT_PREVIEW_HANDLE = "nothing-phone-3a-pro-anime",
        collectionSelect = document.getElementById("select_collection"),
        brandSelect = document.getElementById("select_custom_brand"),
        modelSelect = document.getElementById("select_custom_model"),
        mediaWrapper = document.getElementById("model-media"),
        designWrapper = document.getElementById("design-selector"),
        variantInput = document.getElementById("builder-variant-id-desktop"),
        modelInput = document.getElementById("builder-model-name"),
        designInput = document.getElementById("builder-design-name"),
        brandInput = document.getElementById("builder-brand-name"),
        designImageInput = document.getElementById("builder-design-image"),
        collectionInput = document.getElementById("builder-collection-name"),
        stickyModelName = document.getElementById("sticky-model-name"),
        priceEl = document.getElementById("builder-price-value"),
        addBtn = document.getElementById("builder-add-to-cart"),
        form = document.getElementById("builder-form"),
        skinselect = document.getElementById("skin-type"),
        errorText = document.getElementById("builder-error-text"),
        skinInput = document.getElementById("builder-skin-wrap"),
        errorText2 = document.getElementById("builder-error-text2");

  var html_temp = '';

  document.addEventListener("DOMContentLoaded", () => {

      // if (!addBtn) return;
      hideError(); 

      if(window.location.href.indexOf('build-your-skin-2') == -1 && window.location.href.indexOf('build-your-skin-3') == -1){
        collectionSelect.addEventListener("change", () => {
          hideError(), 
          brandSelect.innerHTML = '<option value="">Select Brand</option>', 
          modelSelect.innerHTML = '<option value="">Select Model</option>', 
          brandSelect.disabled = !0, modelSelect.disabled = !0;

          var collection = collectionSelect.value;
          if (!collection) return;

          collectionInput.value = collectionSelect.options[collectionSelect.selectedIndex].text;
          var brands = Object.keys(window.COLLECTION_MODEL_MAP?.[collection] || {});
          brands.length && (brandSelect.disabled = !1, brands.forEach(b => {
              brandSelect.innerHTML += `<option value="${b}">${capitalize(b)}</option>`
          }))
        });
      }else if(window.location.href.indexOf('build-your-skin-2') > -1){
        var brands = Object.keys(window.COLLECTION_MODEL_MAP?.["transparent"] || {});
        brands.length && (brandSelect.disabled = !1, brands.forEach(b => {
            brandSelect.innerHTML += `<option value="${b}">${capitalize(b)}</option>`
        }))
      }else if(window.location.href.indexOf('build-your-skin-3') > -1){
        var brands = Object.keys(window.COLLECTION_MODEL_MAP?.["3M Premium"] || {});
        brands.length && (brandSelect.disabled = !1, brands.forEach(b => {
            brandSelect.innerHTML += `<option value="${b}">${capitalize(b)}</option>`
        }))
      }
      
      
      brandSelect.addEventListener("change", () => {
        hideError(), 
        modelSelect.innerHTML = '<option value="">Select Model</option>', modelSelect.disabled = !0;
        brandInput.value = brandSelect.value;
        if(window.location.href.indexOf('build-your-skin-2') == -1 && window.location.href.indexOf('build-your-skin-3') == -1){
          var collection = collectionSelect.value,brand = brandSelect.value;
        }else if(window.location.href.indexOf('build-your-skin-2') > -1){
          var collection = "transparent",brand = brandSelect.value;
        }else if(window.location.href.indexOf('build-your-skin-3') > -1){
          var collection = "3M Premium",brand = brandSelect.value;
        }
        
            
        if (!collection || !brand) return;
        const models = window.COLLECTION_MODEL_MAP?.[collection]?.[brand];
        models && (modelSelect.disabled = !1, models.forEach(m => {
              var set_handle = handleize(m.label);
            modelSelect.innerHTML += `<option value="${set_handle}" data-val="${m['skin-type']}" data-cat="${m['category']}">${m.label}</option>`
        }))
      }), 

      modelSelect.addEventListener("change", () => {
          const handle = modelSelect.value;
          // var getSelectVal = modelSelect[modelSelect.selectedIndex].getAttribute('data-val').split(',');
          modelInput.value = modelSelect.value;
          var getSelectVal = modelSelect[modelSelect.selectedIndex].getAttribute('data-val');
          var getVariant = modelSelect[modelSelect.selectedIndex].getAttribute('data-cat');
          if(getVariant == 3){
              document.querySelector('.skin-type').classList.add('hidden');
          }else{
              document.querySelector('.skin-type').classList.remove('hidden');
          }
          let html = ``;
          let counter = 0;
          let counter_blank = 0;
          //addBtn.setAttribute('disabled','disabled');

          fetchImagesSequentially(modelSelect,0,23,0)
          
      });

      skinselect.addEventListener("change", () => {
        hideError();
        const skin_val = skinselect.value;
        skinInput.value = skin_val;
      });

      function attachDesignEvents() {
        const mainImg = document.querySelector(".builder-main-image"), previewSection = document.querySelector(".builder-left");
        document.querySelectorAll(".design-item").forEach(item => {
          const icon = item.querySelector(".design-cart-icon");
          item.addEventListener("click", () => {
            if (document.querySelectorAll(".design-item").forEach(i => i.classList.remove("active")), 
              item.classList.add("active"), mainImg && (mainImg.src = item.dataset.image), 
              designInput.value = item.dataset.design, designImageInput.value = item.dataset.image.replace("&width=900", ""), previewSection) {
              const offsetPosition = previewSection.getBoundingClientRect().top + window.pageYOffset - 100;
              window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
              })
            }
          }), icon.addEventListener("click", e => {
            e.stopPropagation(), addToCart()
          })
        })
      }

      function addToCart(ele) {
          return;
        
        var GetImageLink = ele.closest('.skin-variant-image').querySelector('.product_variant_image').getAttribute('src');
        var GetImageLinkWid = ele.closest('.skin-variant-image').querySelector('.product_variant_image').getAttribute('src').replace(/width=\d+/, "width=800");
        document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').srcset = GetImageLinkWid;
        document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').src = GetImageLinkWid;

        var getCategory = ele.getAttribute('data-cart-item');
        if(getCategory == 1){
          var varData = window.variantLoop["Low"];
        }else if(getCategory == 2){
          var varData = window.variantLoop["Medium"];
        }else{
          var varData = window.variantLoop["High"];
        }

        var checkWrap = !skinselect.value;
        if(getCategory == 3){
          checkWrap = false;
        }
              
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!collectionSelect.value || !brandSelect.value || !modelSelect.value || checkWrap) {
            showError();
            const scrollTarget = collectionSelect.closest(".builder-collection-wrap") || collectionSelect;
            if (scrollTarget) {
                const offsetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 90;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                })
            }
            return
        }
        hideError();
        ele.classList.add('active');
        
        designInput.value = ele.getAttribute('data-design');
        var getCategory = ele.getAttribute('data-cart-item');
        if(getCategory == 1){
          var varData = window.variantLoop["Low"];
        }else if(getCategory == 2){
          var varData = window.variantLoop["Medium"];
        }else{
          var varData = window.variantLoop["High"];
        }
        variantInput.value = varData[0]['id'];
        
        designImageInput.value = GetImageLink;
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(form);
        formData.append('sections',this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
              if (response.status) {
                  return;
              } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
              }
              ele.classList.remove('active');
              this.cart.renderContents(response);
          })
          .catch((e) => {
              console.error("Add to cart failed", e)
          })
          .finally(() => {
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          });
      }

      function showError() {
        if(!skinselect.value){
          errorText2.style.display = "block"
        }else{
          errorText.style.display = "block"
        }
      }

      function hideError() {
        errorText.style.display = "none";
        errorText2.style.display = "none";
      }

      function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1)
      }

      
  })

  async function fetchImagesSequentially(ele,start,end,visitcounter) {

        //console.log(ele.target,'ele');
        if(ele.classList.contains('loadmore-btn')){
          document.querySelector('.variant-images-to-show').classList.add('loading');
          ele.classList.add('loading');
          ele.querySelector('.loadmore-btn .loading__spinner').classList.remove('hidden');
        }
        var getSelectValtemp = modelSelect[modelSelect.selectedIndex].getAttribute('data-val');
        var timeout_start = 100;
        if(ele.classList.contains('loadmore-btn')){
          timeout_start = 1000;
        }
        
        html_temp = "";
        var getSelectVal = getSelectValtemp.split(',');
        //console.log(start,end,'initial values',getSelectVal.length)      
        var getImageCount = start;
        // var getImageCount = start;
        setTimeout(function() {
          for (const [index, linksplit] of getSelectVal.entries()) {
            if(getImageCount > end){
                break;
            }else if(index < start){
                continue;
            }
            //console.log(index,'index',getImageCount,'getImageCount');
            try {
                
                
                var getVariant = modelSelect[modelSelect.selectedIndex].getAttribute('data-cat');
                if(window.location.href.indexOf('build-your-skin-2') == -1 && window.location.href.indexOf('build-your-skin-3') == -1){
                  var Generate_temp_url = collectionSelect.value + '-' + brandSelect.value + '-' + modelSelect.value + '-' + linksplit;
                }else if(window.location.href.indexOf('build-your-skin-2') > -1){
                  var Generate_temp_url = "transparent" + '-' + brandSelect.value + '-' + modelSelect.value + '-' + linksplit;
                }else if(window.location.href.indexOf('build-your-skin-3') > -1){
                  var Generate_temp_url = "3M Premium" + '-' + brandSelect.value + '-' + modelSelect.value + '-' + linksplit;
                }
                var Generate_url = Generate_temp_url.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
                var fetchlink = 'https://cdn.theskins.in/'+Generate_url+'.png'

                if(getVariant == 1){
                    var varData = window.variantLoop["Low"];
                }else if(getVariant == 2){
                    var varData = window.variantLoop["Medium"];
                }else{
                    var varData = window.variantLoop["High"];
                }
                
                // const response = await fetch(fetchlink);
                // const parsedState = await response;
                
                // if(parsedState.ok){
                //     getImageCount++;
                //     html_temp += `<div class="parent-skin-variant"><div class="skin-variant-image">
                //             <img class="product_variant_image" onclick="changeImageInner(this)" src="${parsedState.url}?width=300" loading="lazy" alt="">
                //             <svg id="zoom-icon-cst-skin" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" onclick="openpreview(this)">
                //             <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16407 6.57748C1.16709 3.99351 2.99488 1.77145 5.52975 1.2701C8.06463 0.768736 10.6007 2.12769 11.5871 4.51596C12.5736 6.90423 11.7358 9.65675 9.58595 11.0904C7.43614 12.524 4.57304 12.2395 2.7474 10.4108C1.73196 9.3937 1.16238 8.01472 1.16407 6.57748Z" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9.96875 10.8066L12.8338 13.6608" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7.07812 4.22046C7.07812 3.94432 6.85427 3.72046 6.57813 3.72046C6.30198 3.72046 6.07813 3.94432 6.07813 4.22046H7.07812ZM6.07813 6.57748C6.07813 6.85362 6.30198 7.07748 6.57813 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748H6.07813ZM7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748H7.07812ZM6.07812 8.9345C6.07812 9.21065 6.30198 9.4345 6.57812 9.4345C6.85427 9.4345 7.07812 9.21065 7.07812 8.9345H6.07812ZM6.57812 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748V7.07748ZM4.2211 6.07748C3.94496 6.07748 3.7211 6.30134 3.7211 6.57748C3.7211 6.85362 3.94496 7.07748 4.2211 7.07748L4.2211 6.07748ZM6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748C6.07812 6.85362 6.30198 7.07748 6.57812 7.07748V6.07748ZM8.93515 7.07748C9.21129 7.07748 9.43515 6.85362 9.43515 6.57748C9.43515 6.30134 9.21129 6.07748 8.93515 6.07748V7.07748ZM6.07813 4.22046V6.57748H7.07812V4.22046H6.07813ZM6.07812 6.57748V8.9345H7.07812V6.57748H6.07812ZM6.57812 6.07748L4.2211 6.07748L4.2211 7.07748H6.57812V6.07748ZM6.57812 7.07748H8.93515V6.07748L6.57812 6.07748V7.07748Z" fill="#726F6F"></path>
                //             </svg>
                //             <h4 class="product_variant_title">${linksplit}</h4>
                //             <span class="product_variant_price">${varData[0]['Price'].replace(/\.0+$/, '')}</span>
                //             <div data-design="${linksplit}" data-cart-item="${getVariant}" data-v-id="${varData[0]['id']}" class="atc-instant" onclick="addinnercart(this)">
                //             <span class="text"> Add item </span>
                //             <div class="loading__spinner hidden">
                //                 <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                //                     <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                //                 </svg>
                //             </div>
                //             <div class="success-tick hidden">
                //                 <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                //                 <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                //                 <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                //                 </svg>
                //             </div>
                //             </div>
                //         </div>
                //         <div class="skin-image-preview-popup" style="display:none;" onclick="closepreview(this)">
                //             <div class="close-button-skin-image-preview">
                //             <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                //                 <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#0C1C33"></path>
                //             </svg>
                //             </div>
                //             <div class="selected-skin-image-preview">
                //             <img class="product_variant_image" src="${parsedState.url}?width=800" loading="lazy" alt="">
                //             </div>
                //         </div>
                //         </div>`;
                // }

                getImageCount++;
                html_temp += `<div class="parent-skin-variant"><div class="skin-variant-image">
                        <img class="product_variant_image" onclick="changeImageInner(this)" src="${fetchlink}?width=300" loading="lazy" alt="No Image">
                        <svg id="zoom-icon-cst-skin" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" onclick="openpreview(this)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16407 6.57748C1.16709 3.99351 2.99488 1.77145 5.52975 1.2701C8.06463 0.768736 10.6007 2.12769 11.5871 4.51596C12.5736 6.90423 11.7358 9.65675 9.58595 11.0904C7.43614 12.524 4.57304 12.2395 2.7474 10.4108C1.73196 9.3937 1.16238 8.01472 1.16407 6.57748Z" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9.96875 10.8066L12.8338 13.6608" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7.07812 4.22046C7.07812 3.94432 6.85427 3.72046 6.57813 3.72046C6.30198 3.72046 6.07813 3.94432 6.07813 4.22046H7.07812ZM6.07813 6.57748C6.07813 6.85362 6.30198 7.07748 6.57813 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748H6.07813ZM7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748H7.07812ZM6.07812 8.9345C6.07812 9.21065 6.30198 9.4345 6.57812 9.4345C6.85427 9.4345 7.07812 9.21065 7.07812 8.9345H6.07812ZM6.57812 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748V7.07748ZM4.2211 6.07748C3.94496 6.07748 3.7211 6.30134 3.7211 6.57748C3.7211 6.85362 3.94496 7.07748 4.2211 7.07748L4.2211 6.07748ZM6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748C6.07812 6.85362 6.30198 7.07748 6.57812 7.07748V6.07748ZM8.93515 7.07748C9.21129 7.07748 9.43515 6.85362 9.43515 6.57748C9.43515 6.30134 9.21129 6.07748 8.93515 6.07748V7.07748ZM6.07813 4.22046V6.57748H7.07812V4.22046H6.07813ZM6.07812 6.57748V8.9345H7.07812V6.57748H6.07812ZM6.57812 6.07748L4.2211 6.07748L4.2211 7.07748H6.57812V6.07748ZM6.57812 7.07748H8.93515V6.07748L6.57812 6.07748V7.07748Z" fill="#726F6F"></path>
                        </svg>
                        <h4 class="product_variant_title">${linksplit}</h4>
                        <span class="product_variant_price">${varData[0]['Price'].replace(/\.0+$/, '')}</span>
                        <div data-design="${linksplit}" data-cart-item="${getVariant}" data-v-id="${varData[0]['id']}" class="atc-instant" onclick="addinnercart(this)">
                        <span class="text"> Add item </span>
                        <div class="loading__spinner hidden">
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                        </div>
                        <div class="success-tick hidden">
                            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                            </svg>
                        </div>
                        </div>
                    </div>
                    <div class="skin-image-preview-popup" style="display:none;" onclick="closepreview(this)">
                        <div class="close-button-skin-image-preview">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#0C1C33"></path>
                        </svg>
                        </div>
                        <div class="selected-skin-image-preview">
                        <img class="product_variant_image" src="${fetchlink}?width=800" loading="lazy" alt="No Image">
                        </div>
                    </div>
                    </div>`;
                
                // console.log(`Finished fetch. Array size`);
            } catch (error) {
                console.error(`Error fetching ${fetchlink}:`, error);
            }
            // console.log(visitcounter,'visitcounter')
            visitcounter = visitcounter + 1;
          }

          renderAllImages(getImageCount,getSelectVal,end,visitcounter);
        }, timeout_start);
        
  }

  async function fetchImageData(Generate_url,getVariant,title,counter,getSelectVal,html,counter_blank) {
    try {
        var designImageInput = document.getElementById("builder-design-image"),designWrapper = document.getElementById("design-selector");
        fetch('https://cdn.theskins.in/'+Generate_url+'.png').then((parsedState) => {
            if(parsedState.ok){
                counter = counter + 1;
                if(getVariant == 1){
                    var varData = window.variantLoop["Low"];
                }else if(getVariant == 2){
                    var varData = window.variantLoop["Medium"];
                }else{
                    var varData = window.variantLoop["High"];
                }
                var setDesignCountr = counter-1;
                html += `<div class="parent-skin-variant"><div class="skin-variant-image">
                        <img class="product_variant_image" src="${parsedState.url}?width=300" loading="lazy" alt="">
                        <svg id="zoom-icon-cst-skin" width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" onclick="openpreview(this)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.16407 6.57748C1.16709 3.99351 2.99488 1.77145 5.52975 1.2701C8.06463 0.768736 10.6007 2.12769 11.5871 4.51596C12.5736 6.90423 11.7358 9.65675 9.58595 11.0904C7.43614 12.524 4.57304 12.2395 2.7474 10.4108C1.73196 9.3937 1.16238 8.01472 1.16407 6.57748Z" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M9.96875 10.8066L12.8338 13.6608" stroke="#726F6F" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M7.07812 4.22046C7.07812 3.94432 6.85427 3.72046 6.57813 3.72046C6.30198 3.72046 6.07813 3.94432 6.07813 4.22046H7.07812ZM6.07813 6.57748C6.07813 6.85362 6.30198 7.07748 6.57813 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748H6.07813ZM7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748H7.07812ZM6.07812 8.9345C6.07812 9.21065 6.30198 9.4345 6.57812 9.4345C6.85427 9.4345 7.07812 9.21065 7.07812 8.9345H6.07812ZM6.57812 7.07748C6.85427 7.07748 7.07812 6.85362 7.07812 6.57748C7.07812 6.30134 6.85427 6.07748 6.57812 6.07748V7.07748ZM4.2211 6.07748C3.94496 6.07748 3.7211 6.30134 3.7211 6.57748C3.7211 6.85362 3.94496 7.07748 4.2211 7.07748L4.2211 6.07748ZM6.57812 6.07748C6.30198 6.07748 6.07812 6.30134 6.07812 6.57748C6.07812 6.85362 6.30198 7.07748 6.57812 7.07748V6.07748ZM8.93515 7.07748C9.21129 7.07748 9.43515 6.85362 9.43515 6.57748C9.43515 6.30134 9.21129 6.07748 8.93515 6.07748V7.07748ZM6.07813 4.22046V6.57748H7.07812V4.22046H6.07813ZM6.07812 6.57748V8.9345H7.07812V6.57748H6.07812ZM6.57812 6.07748L4.2211 6.07748L4.2211 7.07748H6.57812V6.07748ZM6.57812 7.07748H8.93515V6.07748L6.57812 6.07748V7.07748Z" fill="#726F6F"></path>
                        </svg>
                        <h4 class="product_variant_title">${title}</h4>
                        <span class="product_variant_price">${varData[0]['Price'].replace(/\.0+$/, '')}</span>
                        <div data-design="${getSelectVal[setDesignCountr]}" data-cart-item="${getVariant}" data-v-id="${varData[0]['id']}" class="atc-instant" onclick="addinnercart(this)">
                        <span class="text"> Add item </span>
                        <div class="loading__spinner hidden">
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                        </div>
                        <div class="success-tick hidden">
                            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                            <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                            </svg>
                        </div>
                        </div>
                    </div>
                    <div class="skin-image-preview-popup" style="display:none;" onclick="closepreview(this)">
                        <div class="close-button-skin-image-preview">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#0C1C33"></path>
                        </svg>
                        </div>
                        <div class="selected-skin-image-preview">
                        <img class="product_variant_image" src="${parsedState.url}?width=800" loading="lazy" alt="">
                        </div>
                    </div>
                    </div>`;
                if(counter === 1){
                    designImageInput.value = `${parsedState.url}?width=400`;
                    document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').srcset = `${parsedState.url}?width=400`;
                    document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').src = `${parsedState.url}?width=800`;
                    if(getVariant == 1){
                        var varData = window.variantLoop["Low"];
                    }else if(getVariant == 2){
                        var varData = window.variantLoop["Medium"];
                    }else{
                        var varData = window.variantLoop["High"];
                    }
                }
            }
        }).catch((e) => {
            console.error(e);
        }).finally(() => {
            counter_blank = counter_blank + 1;

            if(counter == getSelectVal.length){
                designWrapper.innerHTML = html;
                if(designWrapper.querySelector('.parent-skin-variant')){
                  designWrapper.classList.remove('hidden');
                  document.querySelector('.select-design-title').classList.remove('hidden');
                  
                  designWrapper.querySelectorAll('.product_variant_image').forEach((allImages) => {
                      allImages.addEventListener('click',function(){
                        const GetImageLink = allImages.getAttribute('src');
                        const GetImageLinkWid = GetImageLink.replace(/width=\d+/, "width=800");

                        allImages.closest('.parent-skin-variant').classList.add('active-cart');
                        document.querySelector('.product__info-wrapper').classList.add('visible-btn');

                        var get_coll = collectionInput.value;
                        var get_model = brandInput.value + ' ' + modelInput.value + '(' + allImages.closest('.skin-variant-image').querySelector('.product_variant_title').innerText + ')';

                        document.querySelector(".variant__title_buy").innerText = get_coll;
                        document.querySelector(".product__title h3").innerText = get_model;

                        document.querySelector('.sticky-buy-buttons .product__title h3').style.color = '#7b7b7b';
                        document.querySelector('.sticky-buy-buttons .product__title h3').style.fontSize = '12px';
                        document.querySelector('.sticky-buy-buttons .product__title h3').style.lineHeight = '12px';

                        document.querySelector('.d-none-price .price__container .price__sale .price-item--sale').innerHTML = allImages.closest('.skin-variant-image').querySelector('.product_variant_price').innerText;
                        document.querySelector('.d-none-price').style.display = 'block';
                        document.querySelector('.d-none-mrp').style.display = 'block';
                        document.querySelector('.sticky-buy-buttons').style.display = 'flex';

                        document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').srcset = GetImageLinkWid;
                        document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').src = GetImageLinkWid;

                        designImageInput.value = GetImageLink;

                        const scrollTarget = document.querySelector(".product__media-wrapper");
                        if (scrollTarget) {
                            const offsetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 90;
                            window.scrollTo({
                                top: offsetPosition,
                                behavior: "smooth"
                            })
                        }
                      })
                  })
                  modelInput.value = modelSelect.options[modelSelect.selectedIndex].text;
                }
            }else if(counter_blank == getSelectVal.length){
                if(!designWrapper.querySelector('.parent-skin-variant') == false){
                    designWrapper.innerHTML = '';  
                    document.querySelector('.select-design-title').classList.add('hidden');
                }
            }
        });
    } catch (error) {
      console.error("Error fetching single image:", error);
    }
  }

  function changeImageInner(ele){
      //console.log('infunction');
      var allImages = ele;
      const GetImageLink = allImages.getAttribute('src');
      const GetImageLinkWid = GetImageLink.replace(/width=\d+/, "width=800");

      allImages.closest('.parent-skin-variant').classList.add('active-cart');
      document.querySelector('.product__info-wrapper').classList.add('visible-btn');

      var get_coll = collectionInput.value;
      var get_model = brandInput.value + ' ' + modelInput.value + '(' + allImages.closest('.skin-variant-image').querySelector('.product_variant_title').innerText + ')';

      document.querySelector(".variant__title_buy").innerText = get_coll;
      document.querySelector(".product__title h3").innerText = get_model;

      document.querySelector('.sticky-buy-buttons .product__title h3').style.color = '#7b7b7b';
      document.querySelector('.sticky-buy-buttons .product__title h3').style.fontSize = '12px';
      document.querySelector('.sticky-buy-buttons .product__title h3').style.lineHeight = '12px';

      document.querySelector('.d-none-price .price__container .price__sale .price-item--sale').innerHTML = allImages.closest('.skin-variant-image').querySelector('.product_variant_price').innerText;
      document.querySelector('.d-none-price').style.display = 'block';
      document.querySelector('.d-none-mrp').style.display = 'block';
      document.querySelector('.sticky-buy-buttons').style.display = 'flex';

      document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').srcset = GetImageLinkWid;
      document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').src = GetImageLinkWid;

      designImageInput.value = GetImageLink;

      modelInput.value = modelSelect.options[modelSelect.selectedIndex].text;

      const scrollTarget = document.querySelector(".product__media-wrapper");
      if (scrollTarget) {
          const offsetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 90;
          setTimeout(() =>{
              window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth"
              })
          }, 500)
          
      }
  }

  function renderAllImages(getImageCount,getSelectVal,end,visitcounter) {
        var ending_pos = (visitcounter + 23);
        var starting_pos = visitcounter;
        var check_prev_status = visitcounter - 25;
        var prev_counter = visitcounter - 24 - 24;
        //console.log('visitcounter',visitcounter,end)
        //console.log(getImageCount,starting_pos,end,ending_pos,'Next val',visitcounter, getSelectVal.length)
        if (document.querySelector('.loadmore_wrap')){
          document.querySelectorAll('.loadmore_wrap').forEach((ele) => {
            ele.remove();
          });
        } 
        // document.querySelector('.loadmore_wrap') && document.querySelector('.loadmore_wrap).remove();
        if(visitcounter < getSelectVal.length){
            
            var loadmore_html =  `<div class="loadmore_wrap">`

            if(check_prev_status > 0){
              loadmore_html += `<div class="loadmore-btn" onclick="fetchImagesSequentially(this,${prev_counter},${check_prev_status},${prev_counter})">
                  <div class="loading-wrapper">
                      <span class="text"> Prev </span>
                      <div class="loading__spinner hidden">
                          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                      </div>
                  </div>
              </div>`;
            }

            loadmore_html += `<div class="loadmore-btn" onclick="fetchImagesSequentially(this,${starting_pos},${ending_pos},${visitcounter})">
              <div class="loading-wrapper">
                  <span class="text"> Next </span>
                  <div class="loading__spinner hidden">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                  </div>
              </div>
            </div>`;

            loadmore_html +=  `</div>`;

            document.querySelector('.variant-images-to-show').insertAdjacentHTML('afterend', loadmore_html);
        }else{
            var loadmore_html =  `<div class="loadmore_wrap">`

            prev_counter = end - 24 - 23;
            check_prev_status = end - 24;
            // var check_prev_status = visitcounter - 25;

            if(check_prev_status > 0){
              loadmore_html += `<div class="loadmore-btn" onclick="fetchImagesSequentially(this,${prev_counter},${check_prev_status},${prev_counter})">
                  <div class="loading-wrapper">
                      <span class="text"> Prev </span>
                      <div class="loading__spinner hidden">
                          <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                      </div>
                  </div>
              </div>`;
            }

            loadmore_html +=  `</div>`;

            document.querySelector('.variant-images-to-show').insertAdjacentHTML('afterend', loadmore_html);
        }
        document.querySelector('.variant-images-to-show').classList.remove('loading');
        designWrapper.innerHTML = html_temp;
        const scrollTarget = document.querySelector(".built-default-title");
        if (scrollTarget) {
            const offsetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 90;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            })
        }
  }

  function handleize(text) {
    return text.toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9 -]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }

  function openpreview(ele){
    ele.closest('.parent-skin-variant').querySelector('.skin-image-preview-popup').style.display = 'block';
    document.querySelector('.product__info-wrapper').classList.add('visible-btn');
  }

  function closepreview(ele){
    document.querySelector('.product__info-wrapper').classList.remove('visible-btn');
    ele.style.display = 'none';
  }

  function addinnercart(ele){

    var designInput = document.getElementById("builder-design-name");
    var designImageInput = document.getElementById("builder-design-image");
    var variantInput = document.getElementById("builder-variant-id-desktop");
    var form = document.getElementById("builder-form");

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var addToCartBtn = ele;
    
    addToCartBtn.classList.add('loading');
    addToCartBtn.querySelector('.loading__spinner').classList.remove('hidden');

    const skinVariantImage = addToCartBtn.closest('.skin-variant-image');
    if (!skinVariantImage){
      addToCartBtn.classList.toggle('active');
      addToCartBtn.classList.remove('loading');
      addToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
      return;
    }
    const productVariantImage = skinVariantImage.querySelector('.product_variant_image');
    if (!productVariantImage){
      addToCartBtn.classList.toggle('active');
      addToCartBtn.classList.remove('loading');
      addToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
      return;
    }

    const curr_design = addToCartBtn.closest('.skin-variant-image').querySelector('.product_variant_title').textContent.trim();

    const GetImageLink = productVariantImage.getAttribute('src');
    const GetImageLinkWid = GetImageLink.replace(/width=\d+/, "width=800");

    document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').srcset = GetImageLinkWid;
    document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').src = GetImageLinkWid;

    designImageInput.value = GetImageLink;

    if (designInput.value) {if (!values.includes(curr_design)) {values.push(curr_design);}} else {values = [curr_design];}
    designInput.value = values.join(',');

    const scrollTarget = document.querySelector(".product__media-wrapper");
    if (scrollTarget) {
        const offsetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 90;

        addToCartBtn.querySelector('.success-tick').classList.remove('hidden')
        

        setTimeout(function( ) { 
            
          designInput.value = addToCartBtn.getAttribute('data-design');
          var getCategory = addToCartBtn.getAttribute('data-cart-item');
          if(getCategory == 1){
            var varData = window.variantLoop["Low"];
          }else if(getCategory == 2){
            var varData = window.variantLoop["Medium"];
          }else{
            var varData = window.variantLoop["High"];
          }
          variantInput.value = varData[0]['id'];

          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          
          designImageInput.value = GetImageLink;
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          const formData = new FormData(form);
          formData.append('sections',this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    return;
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }
                addToCartBtn.classList.remove('loading');
                addToCartBtn.classList.add('active');
                setTimeout(function( ) {
                  this.cart.renderContents(response);
                }, 800)
            })
            .catch((e) => {
                console.error("Add to cart failed", e)
            })
            .finally(() => {
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                addToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
            });
        }, 500);
        
    }
  }


  function addToCartFirst(ele){
    document.getElementById("builder-error-text").style.display = "block";
    const scrollTarget = document.querySelector(".builder-collection-wrap");
    if (scrollTarget) {
        const offsetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        })
    }
  }

  function addToCart(ele){


      ele.classList.add('loading');
      ele.querySelector('.loading__spinner').classList.remove('hidden');

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const parentDiv = document.querySelector('.variant-images-to-show');
      if (!parentDiv) {
        ele.classList.remove('loading');
        ele.querySelector('.loading__spinner').classList.add('hidden');
        return;
      }

      const activeButtons = parentDiv.querySelectorAll('.atc-instant.active');
      if (!activeButtons.length) {
        document.getElementById('builder-error-text').style.display = 'block';
        setTimeout(function( ) { 
          ele.classList.remove('loading');
          ele.querySelector('.loading__spinner').classList.add('hidden');
        }, 500);
        
        return;
      }

      const variantCounts = {};
      activeButtons.forEach(function(btn) {
        const vId = btn.getAttribute('data-v-id');
        if (vId) {
          variantCounts[vId] = (variantCounts[vId] || 0) + 1;
        }
      });

      const form = document.getElementById("builder-form");
      let properties = {};
      if (form) {
        const formData = new FormData(form);
        for (let [key, val] of formData.entries()) {
          if (key.startsWith('properties[') && key.endsWith(']')) {
              let cleanKey = key.slice(11, -1);
              properties[cleanKey] = val;
          } else if (key !== 'id' && key !== 'quantity' && val !== '' && !key.startsWith('options[')) {
              properties[key] = val;
          }
        }
        
      }

      

      const additems = Object.keys(variantCounts).map(vId => {
        let item = {
          id: vId,
          quantity: variantCounts[vId]
        };
        if (Object.keys(properties).length) {
          item.properties = Object.assign({}, properties);
        }
        return item;
      });


      var final_add_obj = { 
          items : additems
      }

      final_add_obj['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
      final_add_obj['sections_url'] = window.location.pathname;

      // console.log('final_add_obj',final_add_obj);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(final_add_obj)
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function(addData) {
        ele.classList.remove('loading');
        ele.querySelector('.loading__spinner').classList.add('hidden');
        this.cart.renderContents(addData);
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
        document.getElementById('builder-error-text').style.display = 'block';
      });
  }

  function changeImage(ele){
    const GetImageLink = ele.getAttribute('src');
    const GetImageLinkWid = GetImageLink.replace(/width=\d+/, "width=800");

    document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').srcset = GetImageLinkWid;
    document.querySelectorAll("modal-opener .product__media.media")[0].querySelector('img').src = GetImageLinkWid; 

    const scrollTarget = document.querySelector(".product__media-wrapper");
    if (scrollTarget) {
        const offsetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        })
    }
  }

  function triggerSelectedcart(ele){
    if(document.querySelectorAll('.parent-skin-variant.active-cart').length > 0){
      ele.classList.add('loading');
      ele.querySelector('.loading__spinner').classList.remove('hidden');
      document.querySelector('.parent-skin-variant.active-cart .atc-instant').click();
      setTimeout(() => {
        ele.closest('.sticky-buy-buttons').style.display = 'none';
        ele.closest('.sticky-buy-buttons').querySelector('.d-none-price').style.display = 'none';
        ele.closest('.sticky-buy-buttons').querySelector('.d-none-mrp').style.display = 'none';
        document.querySelector('.parent-skin-variant.active-cart').classList.remove('active-cart');
        ele.classList.remove('loading');
        ele.querySelector('.loading__spinner').classList.add('hidden');  
      }, 1000);
    }else{

    }
  }